<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="banner">
  <table>
    <tr>
      <td style="width: 100%">
        <div class="banner-text-container">
          <span class="banner-text" [xdaTranslate]="message"></span>
        </div>
      </td>
      <td>
        <div class="banner-button-container">
          <button
            type="submit"
            class="banner-button xrx-btn btn-secondary btn medium glyph-only-button"
            (click)="close()">
            <span class="xgl-navigate_down"></span>
          </button>
        </div>
      </td>
    </tr>
  </table>
</div>
